import { render, staticRenderFns } from "./HistroyAlarm.vue?vue&type=template&id=2db490b3&scoped=true"
import script from "./HistroyAlarm.vue?vue&type=script&lang=js"
export * from "./HistroyAlarm.vue?vue&type=script&lang=js"
import style0 from "./HistroyAlarm.vue?vue&type=style&index=0&id=2db490b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db490b3",
  null
  
)

export default component.exports